function selectCustom() {
  $('.custom-select').niceSelect();
}

export default selectCustom;